<template>
  <div style="display: flex;justify-content: center;padding-top: 10px">

    <el-descriptions class="margin-top" title="导购员手机号" :column="3" size="medium" border>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-user"></i>
          导购姓名
        </template>
        {{name}}
      </el-descriptions-item>
      <el-descriptions-item>
        <template slot="label">
          <i class="el-icon-mobile-phone"></i>
          手机号
        </template>
        {{mobile}}
      </el-descriptions-item>
<!--      <el-descriptions-item>-->
<!--        <template slot="label">-->
<!--          <i class="el-icon-location-outline"></i>-->
<!--          居住地-->
<!--        </template>-->
<!--        苏州市-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label">-->
<!--          <i class="el-icon-tickets"></i>-->
<!--          备注-->
<!--        </template>-->
<!--        <el-tag size="small">学校</el-tag>-->
<!--      </el-descriptions-item>-->
<!--      <el-descriptions-item>-->
<!--        <template slot="label">-->
<!--          <i class="el-icon-office-building"></i>-->
<!--          联系地址-->
<!--        </template>-->
<!--        江苏省苏州市吴中区吴中大道 1188 号-->
<!--      </el-descriptions-item>-->
    </el-descriptions>
    <el-dialog
      title="请输入验证码"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose">
      <img :src="img">
      <span v-show="captchaErr" style="color: red">{{captchaErr}}</span>
      <el-input v-model="captcha" autocomplete="off"></el-input>
      <span slot="footer" class="dialog-footer">
<!--    <el-button @click="dialogVisible = false">取 消</el-button>-->
    <el-button type="primary" @click="handleConfirm">确 定</el-button>
  </span>
    </el-dialog>
  </div>



</template>

<script>
import {getPhone} from "@/api/SalePhone"
export default {
  name: 'GetPhoneNumber',
  data () {
    return{
      name:'无',
      mobile:'无',
      dialogVisible: false,
      img:'',
      captcha:'',
      code:'',
      captchaErr:''

    }
  },
  created () {
    const url = window.location.href;
    let code = decodeURIComponent(url.split('code=',-1)[1])
    this.code=code
    getPhone(code,'').then(res => {
      if (res.data.code==0){
        alert(res.data.msg)
        this.name = res.data.msg
      }
      if (res.data.date.mobile) {
        this.name = res.data.date.name;
        this.mobile = res.data.date.mobile;
      }
      if (res.data.date.img) {
        this.dialogVisible= true;
        this.img = res.data.date.img
      }
    })
  },
    methods:{
      handleClose(done) {
        // this.$confirm('确认关闭？')
        //   .then(_ => {
        //     done();
        //   })
        //   .catch(_ => {});
      },
      handleConfirm(done) {
        console.log(this.captcha)
        // this.$confirm('确认关闭？')
        //   .then(_ => {
        //     done();
        //   })
        //   .catch(_ => {});
        if (this.captcha.length<4){
          this.captchaErr = '请正确输入验证码'
          return;
        }
        getPhone(this.code,this.captcha).then(res => {
          if (res.data.date.mobile) {
            this.dialogVisible= false;
            this.name = res.data.date.name;
            this.mobile = res.data.date.mobile;
          }
          if (res.data.date.img) {
            this.captchaErr = '验证码错误，请重试'
            this.dialogVisible= true;
            this.captcha = ''
            this.img = res.data.date.img
          }
        })
      }
    }
}
</script>

<style scoped>
@import '../theme/index2.css';
</style>
